import { render, staticRenderFns } from "./headerFIltros.vue?vue&type=template&id=ba6a0772&scoped=true"
import script from "./headerFIltros.vue?vue&type=script&lang=js"
export * from "./headerFIltros.vue?vue&type=script&lang=js"
import style0 from "./headerFIltros.vue?vue&type=style&index=0&id=ba6a0772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6a0772",
  null
  
)

export default component.exports